export const initStateTypeDocuments = (
   Object.assign({
      structure_documents    : [],
      selectedOptionCustomer : '',
      notes                  : '',
      documents_data         : [],
      documentId             : '',
      typeDocumentId         : '',
      isOpen                 : false,
      language               : '',
      format_budget          : '',
      serie                  : '',
      folio                  : '',
      exchange_rate          : '',
      isExchangeRate         : false,
      concepts_tree          : [],
      cover_concept          : '',
      selectedOptionIsabi    : '',
      kind_procedure         : '',
      identifier_document    : '',
      concepts_discounts     : [],
      status_modal           : false,
      payment_date           : '',
      payment_amount         : 0,
      payment_note           : '',
      select_way_payment     : '',
      details_payment        : [],
      details_budget         : '',
      view_payment_edit      : false,
      payment_id             : '',
      file_upload_data       : '',
      payment_confirm        : 0,
      start_date             : '',
      end_date               : '',
      search_text_table      : '',
      type_document_search   : '',
      filter_by_status       : '',
      account_bank           : ''
   })
);